module.exports = __webpack_public_path__ + "static/media/bg.469d1f93.png";